/**
 * Display formatters — currency, date, duration.
 * Konsisten dengan format yang dipakai Worker.
 */

export function formatIDR(amount: number): string {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatDate(iso: string | null | undefined, fallback = "—"): string {
  if (!iso) return fallback;
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return fallback;
    return d.toLocaleDateString("id-ID", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch {
    return fallback;
  }
}

export function formatDateTime(iso: string | null | undefined, fallback = "—"): string {
  if (!iso) return fallback;
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return fallback;
    return d.toLocaleString("id-ID", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return fallback;
  }
}

/**
 * duration_days = 0 berarti produk TIDAK punya masa berlaku.
 *
 * Istilahnya "Sekali Bayar", bukan "Lifetime": yang dijual bisa berupa akun,
 * tautan, atau serial key, dan "lifetime" menjanjikan keabadian yang tidak
 * bisa dijamin penjual. "Sekali Bayar" hanya menyatakan yang benar — tidak ada
 * tagihan berulang dan tidak ada tanggal kedaluwarsa dari sisi kami.
 */
export function formatDuration(days: number): string {
  if (days <= 0) return "Sekali Bayar";
  if (days === 1) return "1 hari";
  if (days < 30) return `${days} hari`;
  if (days === 30) return "30 hari (1 bulan)";
  if (days < 365) return `${days} hari (~${Math.round(days / 30)} bln)`;
  if (days === 365) return "365 hari (1 tahun)";
  return `${days} hari (~${(days / 365).toFixed(1)} thn)`;
}

export function truncate(s: string, n: number): string {
  if (s.length <= n) return s;
  return s.slice(0, n - 1) + "…";
}

export function maskCredential(cred: string): string {
  // Mask password di "user:pass" — sisakan user, hide pass
  const idx = cred.indexOf(":");
  if (idx < 0) return cred; // bukan format user:pass, tampilkan utuh (misal token)
  return `${cred.slice(0, idx)}:${"•".repeat(8)}`;
}